import { useSwrStatic } from "../../helpers/swr";
import { setCookie } from "nookies";
import Style from "./SubscriptionText.module.scss";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const useSubscriptionText = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const myClass = currentPath.endsWith("/ar");
  const rtl = myClass ? Style.rtl : "";
  const { t } = useTranslation(["common"]);

  const { data: basicData } = useSwrStatic(`/basic-details`);

  if (basicData) {
    setCookie(null, "AMOUNT", basicData?.data?.amount);
  }

  return { rtl, basicData, t };
};

export default useSubscriptionText;
